export const DEFAULT_DISPLAY_FILE_NAME_MAX_LENGTH = 30;

export const truncateFileNameForDisplay = (
  name: string,
  maxLength: number = DEFAULT_DISPLAY_FILE_NAME_MAX_LENGTH
): string => {
  if (name.length <= maxLength) {
    return name;
  }

  const lastDot = name.lastIndexOf('.');
  const ext = lastDot >= 0 ? name.slice(lastDot) : '';
  const baseLength = Math.max(1, maxLength - ext.length - 3);

  return `${name.slice(0, baseLength)}...${ext}`;
};
